import Bugsnag from 'services/bugsnag';
import { ParsedUrlQuery } from 'querystring';
import { Brand } from 'types/brand';
import { Campaign, CAMPAIGN_TYPE } from 'types/campaign';
import { StripeCheckoutSession } from 'types/payment';
import { getBrandTrackingPayload, GTagEvent, trackGTagEvent } from './gtag';
import { setSuperProperties, trackEvent } from './mixpanel';
import { MIXPANEL_EVENT } from 'constants/mixpanel';

export const trackCampaignSubmission = async (
  campaignId: string,
  newCampaign: Campaign,
  brand: Brand
) => {
  try {
    const isFirstCampaign = !brand.firstCampaign;
    const { value } = newCampaign;
    //   MixPanel
    trackEvent(MIXPANEL_EVENT.BRAND_LAUNCHES_CAMPAIGN, {
      campaignId,
      isFirstCampaign,
      ...newCampaign,
    });

    //   GTag
    const commonPayload = {
      value,
      currency: 'USD',
      isFirstCampaign,
      external_id: brand.uid,
      ...getBrandTrackingPayload(brand),
    };
    const fbEvent =
      newCampaign.type === CAMPAIGN_TYPE.IMAGE
        ? GTagEvent.FB_IMAGE_CAMPAIGN
        : GTagEvent.FB_VIDEO_CAMPAIGN;
    trackGTagEvent({
      event: fbEvent,
      email_address: brand.email,
      first_name: newCampaign.name,
      ...commonPayload,
    });
    trackGTagEvent({
      event: GTagEvent.LAUNCH_CAMPAIGN,
      ...commonPayload,
    });
  } catch (error) {
    console.error(error);
    Bugsnag.notify((error as any).message || 'Analytics Submit Campaign Error');
  }
};

export const trackInitiateCheckout = (
  brand: Brand,
  checkoutSession: StripeCheckoutSession,
  isFirstTimeCheckoutPromo = false
) => {
  try {
    const brandId = brand.uid;
    const selectedCredits = Number(checkoutSession.metadata?.credits);
    const transactionAmount = Number(checkoutSession.amount_total) / 100;
    const costPerCredit = Math.floor(transactionAmount / selectedCredits);

    trackEvent(MIXPANEL_EVENT.BRAND_STARTS_CHECKOUT, {
      brandId,
      transactionAmount,
      selectedCredits,
      costPerCredit,
      isFirstTimeCheckoutPromo,
      checkoutSessionId: checkoutSession.id,
    });
    trackGTagEvent({
      event: GTagEvent.INITIATE_CHECKOUT,
      ...getBrandTrackingPayload(brand),
      external_id: brandId,
      Credits: selectedCredits,
      ExtraSavings: 0,
      CostPerCredit: costPerCredit,
      TotalCost: transactionAmount,
      isFirstTimeCheckoutPromo,
    });
  } catch (error) {
    console.error(error);
    Bugsnag.notify(
      (error as any).message || 'Analytics Initiate Checkout Error'
    );
  }
};

export const trackCreditsAdded = (brand: Brand, params: ParsedUrlQuery) => {
  const transactionAmount = Number(params.total);
  const selectedCredits = Number(params.credits);
  const costPerCredit = Math.floor(transactionAmount / selectedCredits);
  const transactionId = params.session_id as string;
  const { firstCampaign, lastPurchaseDate } = brand;
  const isFirstPurchase = !firstCampaign && !lastPurchaseDate;
  const brandId = brand.uid;
  setSuperProperties({ brandId });
  trackEvent(MIXPANEL_EVENT.BRAND_PURCHASE_CONFIRMATION, {
    brandId,
    transactionAmount,
    selectedCredits,
    costPerCredit,
    isFirstPurchase,
    transactionId,
  });
  try {
    trackGTagEvent({
      event: GTagEvent.PURCHASE,
      ...getBrandTrackingPayload(brand),
      transaction_id: transactionId,
      external_id: brandId,
      currency: 'USD',
      Credits: selectedCredits,
      value: transactionAmount,
      isFirstPurchase,
    });
  } catch (error) {
    console.error(error);
    Bugsnag.notify((error as any).message || 'Stape Add Credits Error');
  }
};
